import { InjectionToken } from "@angular/core";
import { HttpInterceptor, HttpContextToken } from "@angular/common/http";

/**
 * Injection token for the VersusClient client base API path
 */
export const BASE_PATH_VERSUSCLIENT = new InjectionToken<string>('BASE_PATH_VERSUSCLIENT', {
    providedIn: 'root',
    factory: () => '/api', // Default fallback
});
/**
 * Injection token for the VersusClient client HTTP interceptor instances
 */
export const HTTP_INTERCEPTORS_VERSUSCLIENT = new InjectionToken<HttpInterceptor[]>('HTTP_INTERCEPTORS_VERSUSCLIENT', {
    providedIn: 'root',
    factory: () => [], // Default empty array
});
/**
 * HttpContext token to identify requests belonging to the VersusClient client
 */
export const CLIENT_CONTEXT_TOKEN_VERSUSCLIENT = new HttpContextToken<string>(() => 'VersusClient');
